import styled from '@emotion/styled';
import { MDSTypography } from '../../../atoms/Typography';
import { SubNavPopoverProps } from '../@types';
import { checkIsMatched } from '../@utils';
import { NavItem } from './NavItem';

const Title = styled(MDSTypography)`
  padding: 8.5px 16px 4px 16px;
  ${({ theme }) => {
    return `
      color: ${theme.comp.lnb.color.content.light};
    `;
  }}
`;

const Content = styled.div`
  padding: 8px;
  display: grid;
  gap: 4px;
`;

export const SubPopoverContent = (props: SubNavPopoverProps) => {
  const { label, items, isOpen, value, LinkComponent, onFold, onItemClick } = props;

  if (!items)
    return (
      <MDSTypography size="xs" weight="medium">
        {label}
      </MDSTypography>
    );

  return (
    <div>
      <Title size="xs" weight="medium" color="inherit">
        {label}
      </Title>
      <Content>
        {items.map((item) => {
          const selected =  checkIsMatched(item.path, value);

          return (
            <NavItem
              {...item}
              type="popover"
              isOpen={isOpen}
              value={value}
              LinkComponent={LinkComponent}
              selected={selected}
              onFold={onFold}
              onItemClick={onItemClick}
              parentLabel={label}
              key={item.key}
            />
          );
        })}
      </Content>
    </div>
  );
};
